<template>
  <transition name="modal">

    <!-- New Modal -->
    <div class="modal-overlay" style="opacity: 1.09; display: block;">
      <div class="modal-wrapper showSweetAlert visible" data-custom-class="" data-has-cancel-button="true" data-has-confirm-button="true" data-allow-outside-click="false" data-has-done-function="true" data-animation="pop" data-timer="null" style="display: block; margin-top: -191px;">

        <em class="sa-icon sa-error fa fa-warning"></em>
        <h2 class="modal-title">There is a problem</h2>
          <p class="modal-paragraph" v-for="error in reducedErrors">
            {{ error }}
          </p>

        <div class="modal-buttons">
            <slot name="body">
              <div class="row">
                <div class="col-md-12 text-center">
                  <button class="btn btn-primary btn-lg btn-accept" @click="closeModal()">OK</button>
                </div>
              </div>
            </slot>
          </div>

      </div>
    </div>
  </transition>
</template>

<script>
  import {
    mapMutations,
    mapState,
  } from 'vuex';
  import {
    HIDE_ERRORS_MODAL,
  } from '@/store/mutation-types';

  export default {
    name: 'errors',
    data() {
      return {
        message: '',
      };
    },
    computed: {
      ...mapState('errors', [
        'listErrors',
      ]),
      reducedErrors() {
        if (Array.isArray(this.listErrors)) {
          return this.listErrors.slice(0, 3);
        }

        return this.listErrors;
      },
    },
    methods: {
      ...mapMutations('errors', {
        hideErrorsModal: HIDE_ERRORS_MODAL,
      }),
      closeModal() {
        this.hideErrorsModal();
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .modal-wrapper p {
    font-size: 16px;
    text-align: center;
  }
  .modal-title {
    color: #f05050;
    text-align: center;
  }
  .modal-buttons {
    border-top: 1px solid #e5e5e5;
    position: relative;
    padding: 15px;
    margin-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// Errors.vue?06ab65fb